import { Component, Input } from '@angular/core';
import * as Setting from '../../../../assets/settings.json';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: '<language>',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css'],
})
export class LanguageComponent {
  @Input() isRTL: boolean;

  @Input() classSize!: string;
  @Input() needAnimation!: boolean;

  constructor(
    private translate: TranslateService,
    private cookieService: CookieService,
    private titleService: Title,
    private router: Router
  ) {
    this.isRTL = true;
    var cultureCookieValue = this.cookieService.get('Culture');
    if (cultureCookieValue == '') {
      this.thisCulture = this.data.culture[0];
    } else {
      this.thisCulture = this.data.culture.filter(
        (current) => current.languageCultureName === cultureCookieValue
      )[0];
    }
    if (this.thisCulture == null) {
      this.thisCulture = this.data.culture[0];
    }
  }

  public thisCulture: any;
  public data: any = Setting;

  public changeCulture(language: string) {
    this.translate.use(language);
    this.thisCulture = this.data.culture.filter(
      (current) => current.shorCode === language
    )[0];

    var htmlTag = document.getElementsByTagName('html')[0];
    if (this.thisCulture.IsRightToLeft) {
      htmlTag.setAttribute('dir', 'rtl');
    } else {
      htmlTag.setAttribute('dir', 'ltr');
    }
    this.cookieService.set('Culture', this.thisCulture.languageCultureName);

    const pageTitle = this.router.url.replace('/', '');
    this.translate.get(pageTitle).subscribe((translatedTitle: string) => {
      this.titleService.setTitle(translatedTitle);
    });
  }

  public generateClass(): string {
    if (this.needAnimation == true) {
      if (this.isRTL == false) {
        return 'animate__animated  animate__fadeInRight animate__delay-4-4s';
      } else {
        return 'animate__animated  animate__fadeInLeft animate__delay-4-4s';
      }
    }
    return '';
  }
}
